import { useSubscribe } from '../layout/useSubscribe';

/** Carte d'inscription à la newsletter, pour la colonne latérale des articles. */
export default function SubscribeCard() {
  const { email, setEmail, status, submit } = useSubscribe();
  return (
    <div className="bg-charcoal p-8 text-white">
      <div className="text-xs font-normal uppercase tracking-[0.0625rem] text-brand">Newsletter</div>
      <h2 className="mt-3 text-white font-display text-[1.75rem] font-bold normal-case leading-tight tracking-normal">Restez informé de nos actualités</h2>
      <p className="mt-3 text-[0.9375rem] leading-relaxed text-white/80">Recevez nos actualités et nos projets directement dans votre boîte mail.</p>
      <form onSubmit={submit} className="mt-6 space-y-3">
        <label className="sr-only" htmlFor="article-newsletter">Adresse e-mail</label>
        <input id="article-newsletter" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Votre adresse e-mail" className="h-12 w-full rounded-[2px] border border-transparent bg-white px-4 text-base text-black placeholder:text-ink/70 focus:border-brand focus:outline-none" />
        <button type="submit" disabled={status === 'loading'} className="h-12 w-full rounded-[2px] border border-brand text-[0.875rem] font-normal uppercase tracking-[0.094rem] text-brand transition-colors duration-300 hover:border-brand-dark hover:bg-brand-dark hover:text-white disabled:opacity-60">
          {status === 'loading' ? 'Envoi…' : 'S’abonner'}
        </button>
      </form>
      <div role="status" aria-live="polite" className="mt-3 text-sm">
        {status === 'ok' && 'Merci, votre inscription est bien enregistrée.'}
        {status === 'error' && 'Une erreur est survenue. Veuillez réessayer.'}
      </div>
    </div>
  );
}
